import { IReferenceData } from 'src/shared/types/Common';
import { REFERENCE_DATA_KEY } from '../../../utils/constants/queryKeys';
import { createApiFetcher } from 'src/utils/ApiUtils';

const fetchData = createApiFetcher(`${REFERENCE_DATA_KEY}/`);

export const getReferenceData = (category: string): Promise<IReferenceData[]> => fetchData(category);
